var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "GiftList",
      "extra-items": ['設定贈品照片']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("設定贈品照片")])])]), _vm.gift != null ? _c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.gift.name) + " ")]) : _vm._e(), _c('img', {
    staticClass: "s-cropped-image",
    attrs: {
      "src": _vm.image
    }
  }), _c('ImageSelector', {
    on: {
      "input": function input($event) {
        return _vm.handleImagesChange($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          attrs: {
            "disabled": !_vm.canClick
          },
          on: {
            "click": openFileSelector
          }
        }, [_vm.canClick ? [_c('div', {
          staticClass: "add-image-icon"
        }, [_vm._v("＋")]), _c('div', [_vm._v("更換圖片")])] : [_vm._v(" 上傳中... ")]], 2)];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.gotoGiftList
    }
  }, [_vm._v("回商品列表")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }